export default { sha: 'd0cf6ab6c37053afeccb3f58a44d9992db4fecf2', buildNumber: 'undefined' }
